import cx from 'classnames'

import styles from './Spinner.module.scss'

const TONE_CLASS_NAMES = {
  primary: styles.tonePrimary,
  white: styles.toneWhite
}

const Spinner = ({ className, size = 16, tone = 'primary' }) => (
  <span
    className={cx(styles.spinner, TONE_CLASS_NAMES[tone], className)}
    style={{
      '--spinner-border-width': `${Math.max(2, Math.round(size / 8))}px`,
      '--spinner-size': `${size}px`
    }}
  />
)

export default Spinner
